module.exports = __webpack_public_path__ + "static/lightdark-ba2b0009e1680dd5bc873ffd7e019795.png";